import React, { Component } from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { connect } from "react-redux";
import RingLoader from "react-spinners/RingLoader";
import { loginAdm } from "../actions/index.actions";
import { Card } from "../components/Card/Card";
import Button from "../components/CustomButton/CustomButton";
import FormInputs from "../components/FormInputs/FormInputs";

const mapStateToProps = (state, props) => {
  const { request, response } = state.admin;
  return {
    fetching: state.fetching,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLogin(username, password) {
    dispatch(loginAdm(username, password));
  },
});

class Login extends Component {
  state = {
    username: process.env.NODE_ENV === "development" ? "rashtell" : "",
    password: process.env.NODE_ENV === "development" ? "rashtell" : "",
  };

  render() {
    const { onLogin, fetching } = this.props;
    const { username, password } = this.state;

    return (
      <div className="content">
        <Grid fluid>
          <div className="card">
            <div className="header">
              <h4 className="title">
                <RingLoader size={30} loading={fetching} />
                Admin
              </h4>

              <p className="category">Super user</p>
            </div>

            <div className="content">
              <Grid fluid>
                <Row>
                  <Col md={8}>
                    <Card
                      title="Login"
                      content={
                        <form>
                          <FormInputs
                            ncols={["col-md-12"]}
                            properties={[
                              {
                                label: "Username",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Username",
                                value: username,

                                onChange: (e) => {
                                  let value = e.currentTarget.value;
                                  this.setState({ username: value });
                                },
                              },
                            ]}
                          />
                          <FormInputs
                            ncols={["col-md-12"]}
                            properties={[
                              {
                                label: "Password",
                                type: "password",
                                bsClass: "form-control",
                                placeholder: "Password",
                                value: password,
                                onChange: (e) => {
                                  let value = e.currentTarget.value;
                                  this.setState({ password: value });
                                },
                              },
                            ]}
                          />

                          <Button
                            bsStyle="primary"
                            fill
                            type="submit"
                            onClick={(e) => {
                              e.preventDefault();
                              onLogin(username, password);
                            }}
                          >
                            Login
                          </Button>
                          <div className="clearfix" />
                        </form>
                      }
                    />
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
